import Typography from '@mui/material/Typography';
import { Button, Modal, Box } from '@mui/material';
import { useState, useContext } from 'react';
import AuthContext from 'src/store/auth-context';
import { colors } from 'src/styles/theme';

const RemoveModal = ({ itemTitle = '', onRemove = () => {} }) => {
  const [open, setOpen] = useState(false);
  const { backdoor } = useContext(AuthContext);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        id="remove-modal-button"
        variant="outlined"
        onClick={handleOpen}
        color="error"
        data-cy="remove-modal-button"
        disabled={backdoor}
      >
        Remove
      </Button>
      <Modal
        hideBackdrop
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        sx={{
          display: 'flex',
          p: 1,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            bgcolor: 'background.paper',
            border: `2px solid ${colors.primary.dark}`,
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
          }}
        >
          <Typography style={{ textAlign: 'center' }} variant="h6" component="h2">
            Are you sure you want to remove {itemTitle}?
          </Typography>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: '1rem',
              gap: '0.5rem',
            }}
          >
            <Typography
              id="keep-mounted-modal-title"
              variant="h6"
              component="h2"
              onClick={handleClose}
            >
              <Button id="remove-no" sx={{ mt: '0.25rem', ml: '0.125rem' }} variant="outlined">
                No
              </Button>
            </Typography>

            <Typography
              id="keep-mounted-modal-title"
              variant="h6"
              component="h2"
              onClick={() => {
                handleClose();
                onRemove();
              }}
            >
              <Button
                data-cy="remove-yes"
                id="remove-yes"
                type="submit"
                sx={{ mt: '0.25rem', ml: '0.125rem' }}
                variant="contained"
              >
                Yes
              </Button>
            </Typography>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default RemoveModal;
